import { render, staticRenderFns } from "./TipoDescontoCadastro.vue?vue&type=template&id=5d3ffa0e&"
import script from "./TipoDescontoCadastro.vue?vue&type=script&lang=js&"
export * from "./TipoDescontoCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports